import { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import autoBind from 'react-autobind';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames/bind';
import axios from 'axios';
import isEqual from 'lodash-es/isEqual';

import { isMobileOnly } from 'react-device-detect';
import loadable from '../../../../../../utils/loadable';
import { GOLD } from '../../../../../../data/permissions';
import { orderValuesTab, sentimentValuesTab, STORIES_LIMIT } from '../../../../../../data/filters/storyFilters';
import StoriesSvc from '../../../../../../services/StoriesSvc';
import { compareFilters } from '../../../../../../helpers/helpers';
import { pickParams, removeEmptyProperties } from '../../../../../../helpers/commonHelpers';
import * as storyFiltersActions from '../../../../../../actions/storyFilters.action';
import * as storyActions from '../../../../../../actions/stories.actions';
import * as preferencesActions from '../../../../../../actions/preferencesActions';
import * as locationsSentiment from '../../../../../../actions/locationsSentiment.actions';

import permissionsDecorator from '../../../../../../decorators/permissionsDecorator';

import OpenFiltersButton from '../../../../../StoryFilters/StoryFiltersButton/OpenFiltersButton';
import StoryFilters from '../../../../../StoryFilters';
import NewStoriesButton from '../../../../../Buttons/NewStoriesButton';
import Preloader from '../../../../../Preloader';
import StoryCard from '../../../../../TrendingStories/StoryCard';
import RecommendedStories from '../../../../../RecommendedStories';
import StoryCaughtUp from '../../../../../StoryCaughtUp';

import StorageSvc from '../../../../../../services/StorageSvc';
import { removeSentimentFromPath } from '../../../../../../helpers/topicsHelpers';
import Styles from './styles.module.scss';
import ScrollableTabs from '../../../../../Shared/ScrollableTabs';

const Masonry = loadable(() => import('react-masonry-component'));
const cx = classNames.bind(Styles);

class PremiumStories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSentimentTab: 'all',
      isAdvancedView: true,
      activeOrderTab: 'top',
      initialStoriesLoaded: false,
    };
    autoBind(this);
    this.isTabActive = false;
    this.timer = 0;
    this.storyUpdateTimer = 0;
    this.newStoriesFetching = false;
    this.storiesRef = createRef();
    this.mobileNewStoriesRef = createRef();
    this.storiesListRef = createRef();

    this.cancelToken = axios.CancelToken;
    this.sourceCancelToken = this.cancelToken.source();
    this.tabsBar = createRef();
    try {
      this.userSimplifiedView = JSON.parse(StorageSvc.getItem('userSimplifiedView'));
    } catch (e) {
      this.userSimplifiedView = false;
    }
  }

  componentDidMount() {
    this.isTabActive = true;
    const { storyFilters, history, actions } = this.props;
    this.fetchSelectedTabs();
    const sentimentName = history.location.pathname.split('/').reverse()[0];
    this.setState({
      isAdvancedView: ((['all', 'very_positive', 'positive', 'neutral', 'negative', 'very_negative'].includes(sentimentName)) || this.userSimplifiedView),
    }, () => {
      const { isAdvancedView, activeSentimentTab } = this.state;
      StorageSvc.setItem(
        'selectedSentimentTab',
        JSON.stringify({ activeSentimentTab }),
      );
      actions.setSentimentTab(activeSentimentTab);
      if (isAdvancedView) {
        history.push(`${removeSentimentFromPath(history.location.pathname)}/${activeSentimentTab}`);
      } else if (!isAdvancedView) {
        history.push(removeSentimentFromPath(history.location.pathname));
      }
    });
    this.loadStories(storyFilters);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  componentDidUpdate(prevProps) {
    const {
      storyFilters, selectedMainTimePeriod, selectedLocation, isMajorOnly,
    } = this.props;

    if (
      !compareFilters(storyFilters, prevProps.storyFilters)
      || selectedMainTimePeriod !== prevProps.selectedMainTimePeriod
      || !isEqual(selectedLocation, prevProps.selectedLocation)
      || isMajorOnly !== prevProps.isMajorOnly
    ) {
      this.setState({
        pageToken: null,
        newStoriesAvailable: false,
      }, () => {
        this.loadStories(storyFilters);
      });
    }
  }

  componentWillUnmount() {
    this.isTabActive = false;
    this.stopTimers();
    clearTimeout(this.loadStoriesTimeout);
    clearTimeout(this.storyUpdateTimer);
    if (this.sourceCancelToken) this.sourceCancelToken.cancel();
    window.removeEventListener('scroll', this.onScroll);
    const { actions } = this.props;
    actions.resetStoriesReduxData();
    actions.freezeStories(false);
    actions.toggleStoryFilters(false);
    window.removeEventListener('visibilitychange', this.onVisibilityChange);
    if (this.sourceCancelToken) this.sourceCancelToken.cancel();
  }

  handleOrderTabClick(activeOrderTab) {
    const { actions, token, piwikEnabled } = this.props;
    actions.toggleStoryFilters(false);
    StorageSvc.setItem(
      'selectedOrderTab',
      JSON.stringify({ activeOrderTab }),
    );
    if (piwikEnabled) _paq.push(['trackEvent', 'Filters', 'Story order', activeOrderTab]);
    this.setState({
      activeOrderTab,
    }, () => {
      const { activeOrderTab } = this.state;
      actions.filterByStoryOrder(activeOrderTab, token);
    });
  }

  handleSentimentTabClick(activeSentimentTab) {
    const { actions, history } = this.props;
    actions.toggleStoryFilters(false);
    actions.setSentimentTab(activeSentimentTab);
    StorageSvc.setItem(
      'selectedSentimentTab',
      JSON.stringify({ activeSentimentTab }),
    );
    this.setState({
      activeSentimentTab,
    }, () => {
      const { activeSentimentTab } = this.state;
      if (activeSentimentTab) {
        history.push(`${removeSentimentFromPath(history.location.pathname)}/${activeSentimentTab}`);
      }
    });
  }

  handleSimplifiedViewTabsClick(show) {
    const { actions, history, token } = this.props;
    this.setState({
      isAdvancedView: show,
    }, () => {
      const { isAdvancedView, activeSentimentTab, activeOrderTab } = this.state;
      if (isAdvancedView) {
        history.push(`${removeSentimentFromPath(history.location.pathname)}/${activeSentimentTab}`);
        actions.filterByStoryOrder(activeOrderTab, token);
        StorageSvc.setItem(
          'selectedOrderTab',
          JSON.stringify({ activeOrderTab }),
        );
      } else {
        history.push(removeSentimentFromPath(history.location.pathname));
      }
    });
  }

  handleFilterRefreshClick() {
    const { storyFilters } = this.props;
    this.setState({
      pageToken: null,
      newStoriesAvailable: false,
    });
    this.loadStories({
      ...storyFilters,
      isRefresh: true,
    });
  }

  onVisibilityChange() {
    if (document.hidden) {
      clearTimeout(this.loadStoriesTimeout);
      this.loadStoriesTimeout = 0;
      if (this.sourceCancelToken) this.sourceCancelToken.cancel();
      this.isTabActive = false;
    } else {
      if (!this.sourceCancelToken) this.sourceCancelToken = this.cancelToken.source();
      clearTimeout(this.storyUpdateTimer);
      this.storyUpdateTimer = 0;
      this.isTabActive = true;
      const { storyFilters } = this.props;
      this.loadStories(storyFilters);
    }
  }

  onScroll() {
    const { promobarHeight, isSummary } = this.props;
    const docTop = this.storiesRef.current.offsetTop;
    const docHeight = this.storiesRef.current.offsetHeight;
    const winheight = window.innerHeight === undefined
      ? document.documentElement.clientHeight
      : window.innerHeight;
    const scrollpoint = window.scrollY === undefined
      ? window.document.documentElement.scrollTop
      : window.scrollY;

    const storiesTop = this.storiesRef.current.getBoundingClientRect().top;
    const isFilterFixed = isSummary ? (storiesTop - 20) <= 0 : (storiesTop - 40 - 20) <= 0;

    const newStoriesTop = this.mobileNewStoriesRef.current.getBoundingClientRect().top;
    const isNewStoriesFixed = isSummary
      ? (newStoriesTop - 20) <= 0 : (newStoriesTop - 40 - 20) <= 0;

    this.setState({
      isFilterFixed,
      filterTop: promobarHeight + (isSummary ? 0 : 40),
      isNewStoriesFixed,
    });

    if ((scrollpoint + winheight) >= (docHeight + docTop)) {
      this.onScrollLoadData();
    }
  }

  async onScrollLoadData() {
    const { loading, storyFilters } = this.props;
    const { initialStoriesLoaded, pageToken } = this.state;
    if (this.newStoriesFetching || loading || !initialStoriesLoaded) return;

    if (pageToken !== 'EOD') {
      this.newStoriesFetching = true;
      await this.loadStories(storyFilters, true);
      this.newStoriesFetching = false;
    }
  }

  getParams(filters) {
    const { activeSentimentTab, isAdvancedView } = this.state;
    const { isMajorOnly, whiteListId } = this.props;
    const params = pickParams(
      { ...filters },
      'categories', 'order_by', 'languages', 'min_score',
      'all_languages', 'startup_categories',
      'events', 'twitter_following_only', 'with_links',
      'source', 'translate_to', 'premium_only', 'page_token',
      'blacklisted_domain_ids', 'whitelisted_domain_ids', 'domains_filtering_mode',
      'isRefresh', 'time_filter',
    );

    if (filters.all_languages) delete params.languages;

    params.all_languages = Boolean(filters.all_languages);
    params.premium_only = true;
    params.categories = isMajorOnly ? 'mp' : 'mp,op,r';
    params.fold_similar_stories = filters.group_similar_stories;

    if (whiteListId) {
      params.domains_filtering_mode = 'whitelist';
      params.whitelisted_domain_ids = [+whiteListId];
    } else {
      delete params.whitelisted_domain_ids;
    }

    if (isAdvancedView && activeSentimentTab !== 'all') {
      params.sentiment_levels = activeSentimentTab;
    }

    removeEmptyProperties(params);

    return params;
  }

  async loadStories(filters, nextPage = false) {
    const {
      storyFilters,
      freezeStories,
    } = this.props;
    if (!storyFilters.conflictsChecked) return;
    const { isFilterFixed } = this.state;

    clearTimeout(this.loadStoriesTimeout);
    // Load stories when only when second timeout call when be the same value and not frozen
    if (filters.refresh_rate === storyFilters.refresh_rate && !freezeStories
      && (!filters.isTimeout || (filters.isTimeout && !isFilterFixed))
      && this.isTabActive) {
      const cancelled = await this.fetchStories(nextPage, filters);
      if (cancelled) return;
    }

    if (filters.isScrollTop) {
      clearTimeout(this.storyUpdateTimer);
      this.storyUpdateTimer = 0;
      this.loadStoriesTimeout = setTimeout(this.loadStories, filters.refresh_rate,
        { ...filters, isTimeout: true });
      return;
    }

    if (filters.refresh_rate !== 'never' && Number(filters.refresh_rate) && this.isTabActive) {
      if (nextPage || isFilterFixed) {
        if (!this.storyUpdateTimer) {
          this.storyUpdateTimer = setTimeout(this.checkForUpdate, filters.refresh_rate);
        }
      } else {
        clearTimeout(this.storyUpdateTimer);
        this.storyUpdateTimer = 0;
        this.loadStoriesTimeout = setTimeout(this.loadStories, filters.refresh_rate,
          { ...filters, isTimeout: true });
      }
    }
  }

  async checkForUpdate() {
    const { storyFilters, stories, earliestSearchDate } = this.props;

    const params = this.getParams(storyFilters);
    const { stories: newStories, cancelled } = await StoriesSvc
      .getStories(params, earliestSearchDate, {
        token: this.sourceCancelToken.token, skipSmallList: true,
      });

    if (cancelled) return;

    const nonDuplicateStoriesIds = new Set([
      ...stories.slice(0, STORIES_LIMIT).map(({ id }) => id),
      ...newStories.map(({ id }) => id),
    ]);

    if (nonDuplicateStoriesIds.size > STORIES_LIMIT) {
      this.setState({
        newStoriesAvailable: true,
      });
    } else {
      const { isFilterFixed } = this.state;
      if (isFilterFixed) {
        this.storyUpdateTimer = setTimeout(this.checkForUpdate, storyFilters.refresh_rate);
      } else {
        clearTimeout(this.storyUpdateTimer);
        this.storyUpdateTimer = 0;
        this.loadStoriesTimeout = setTimeout(this.loadStories, storyFilters.refresh_rate,
          { ...storyFilters, isTimeout: true });
      }
    }
  }

  async fetchStories(nextPage = false, filters = {}) {
    const {
      stories: currentStories,
      actions,
      earliestSearchDate,
      freezeStories,
      storyFilters,
    } = this.props;
    const {
      initialStoriesLoaded, pageToken,
    } = this.state;

    if (!storyFilters.conflictsChecked) return;

    this.stopTimers();
    const params = {
      ...this.getParams({ ...storyFilters, ...filters }),
      ...(nextPage && {
        page_token: pageToken,
      }),
    };

    if (!freezeStories) {
      actions.fetchTrendingStoriesBegin();

      if (!nextPage) {
        clearTimeout(this.loadStoriesTimeout);
        clearTimeout(this.storyUpdateTimer);
      }

      if (this.sourceCancelToken) this.sourceCancelToken.cancel();

      this.cancelToken = axios.CancelToken;
      this.sourceCancelToken = this.cancelToken.source();

      const { stories, nextPageToken, cancelled } = await StoriesSvc
        .getStories(params, earliestSearchDate, {
          token: this.sourceCancelToken.token,
          callCurationActions: true,
          skipSmallList: true,
        });

      if (cancelled) return cancelled;

      actions.fetchTrendingStoriesSuccess(
        nextPage ? [
          ...currentStories,
          ...stories,
        ] : (
          stories
        ),
      );
      this.setState({
        pageToken: nextPageToken,
      });

      if (!initialStoriesLoaded) this.setState({ initialStoriesLoaded: true });
    }
  }

  stopTimers() {
    clearTimeout(this.timer);
  }

  sendUpgradeAction() {
    const { piwikEnabled } = this.props;

    if (piwikEnabled) _paq.push(['trackEvent', 'Premium', 'Upgrade', window.location.href]);
  }

  scrollToStart(fetchNewStories = true) {
    const { storyFilters } = this.props;

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    this.setState({
      newStoriesAvailable: false,
    });
    if (fetchNewStories) {
      this.loadStories({ ...storyFilters, isScrollTop: true });
    }
  }

  returnStories() {
    const { stories } = this.props;
    return stories;
  }

  fetchSelectedTabs() {
    const { history, actions, token } = this.props;
    const getSelectedOrderTab = JSON.parse(StorageSvc.getItem('selectedOrderTab'));
    const getSelectedSentimentTab = JSON.parse(StorageSvc.getItem('selectedSentimentTab'));
    const sentimentName = history.location.pathname.split('/').reverse()[0];

    if (getSelectedOrderTab?.activeOrderTab) {
      this.setState({
        activeOrderTab: getSelectedOrderTab?.activeOrderTab || 'top',
      }, () => {
        const { activeOrderTab } = this.state;
        actions.filterByStoryOrder(activeOrderTab, token);
      });
    }
    if (['all', 'very_positive', 'positive', 'neutral', 'negative', 'very_negative'].includes(sentimentName)) {
      this.setState({
        activeSentimentTab: sentimentName,
      }, () => {
        const { activeSentimentTab } = this.state;
        StorageSvc.setItem(
          'selectedSentimentTab',
          JSON.stringify({ activeSentimentTab }),
        );
      });
    } else if (getSelectedSentimentTab?.activeSentimentTab) {
      this.setState({
        activeSentimentTab: getSelectedSentimentTab?.activeSentimentTab || 'all',
      });
    }
  }

  render() {
    const {
      initialStoriesLoaded, activeSentimentTab,
      activeBoxTab,
      isFilterFixed, filterTop,
      newStoriesAvailable, isNewStoriesFixed,
      pageToken,
      isAdvancedView,
      activeOrderTab,
    } = this.state;
    const {
      user,
      windowWidth,
      loading,
      storyFilters,
      actions,
      isMajorOnly,
      whiteListId,
      classname,
      activatePreloader,
      singlePremiumNews,
    } = this.props;

    const storiesArr = this.returnStories();
    const isCompactView = isMobileOnly ? (
      storyFilters.user_newsfeed_compactview
    ) : (
      storyFilters.user_newsfeed_compactview_web
    );
    const userNewsfeedView = isMobileOnly ? (
      storyFilters.user_newsfeed_view
    ) : (
      storyFilters.user_newsfeed_view_web
    );
    const isTilesView = userNewsfeedView === 'tiles' && !isCompactView;

    return (
      <div className={Styles.premium_stories}>
        <div className={Styles.premium_stories_box}>
          <div
            className={cx('premium_stories_section', {
              tiles: isTilesView, active: activeBoxTab === 'stories',
            })}
            ref={this.storiesRef}
          >
            <div className={cx('simplifiedview__Tabs', isAdvancedView ? 'show' : '')}>
              <ScrollableTabs
                tabs={orderValuesTab}
                activeTab={activeOrderTab}
                onTabClick={this.handleOrderTabClick}
                ref={this.tabsBar}
                classname="publicationTabs"
              />
              <ScrollableTabs
                tabs={sentimentValuesTab}
                activeTab={activeSentimentTab}
                onTabClick={this.handleSentimentTabClick}
                ref={this.tabsBar}
                classname="publicationTabs"
              />
            </div>
            <div className={Styles.filters_container}>
              <OpenFiltersButton
                className={Styles.custom_filter}
                refreshEvent={this.handleFilterRefreshClick}
                onSimplifiedViewTabsClick={this.handleSimplifiedViewTabsClick}
                isSimpleLayout={isAdvancedView}
                hasBigScreenDesign
                isPremiumPage
              />
              <NewStoriesButton
                className={cx('new-stories-btn', { visible: newStoriesAvailable, fixed: isFilterFixed && windowWidth > 767 })}
                onClick={this.scrollToStart}
                style={{ top: `${isFilterFixed && windowWidth > 767 ? filterTop + 15 : 0}px` }}
                hasBigScreenDesign
              />
            </div>
            <div className={Styles.filter_bar}>
              <StoryFilters
                isSimpleLayout={isAdvancedView}
                isDisabled
                hasBigScreenDesign
                isPremiumPage
                onSimplifiedViewTabsClick={this.handleSimplifiedViewTabsClick}
              />
            </div>
            <div
              ref={this.mobileNewStoriesRef}
              className={cx('new-stories-btn_mobile', { show: newStoriesAvailable })}
            >
              <NewStoriesButton
                className={cx('new-stories-btn', { visible: newStoriesAvailable, fixed: isNewStoriesFixed })}
                onClick={this.scrollToStart}
              />
            </div>
            <div
              className={cx('premium_stories_cards', {
                loading: loading && !this.newStoriesFetching,
                tiles: isTilesView,
              })}
            >
              {(!initialStoriesLoaded || activatePreloader) ? (
                <Preloader
                  loading
                  static
                  centered
                />
              ) : (
                <Masonry
                  disableImagesLoaded
                  options={{
                    gutter: 10,
                    percentPosition: true,
                    resize: false,
                    isResizeBound: false,
                    transitionDuration: 0,
                  }}
                  className={cx({
                    tiles_wrapper: isTilesView,
                    without_tiles: !isTilesView && isCompactView,
                  })}
                  ref={(c) => { this.masonry = this.masonry || c.masonry; }}
                >
                  {storiesArr.map((story) => (
                    <StoryCard
                      key={story.id}
                      user={user}
                      type={story.type}
                      story={story}
                      onHide={actions.hideStory}
                      onFreezeStories={actions.freezeStories}
                      onLikeChanged={actions.updateStoriesInfo}
                      onBookmarkClick={actions.updateStoriesBookmark}
                      loading={loading}
                      masonryObj={this.masonry}
                      isGoldIcon
                      hasBigScreenDesign
                      disableMainDomainImageLoad={singlePremiumNews}
                    />
                  ))}
                </Masonry>
              )}
              {loading && this.newStoriesFetching && (
                <Preloader
                  loading
                  static
                  centered
                />
              )}

              {(storiesArr.length < 20
                && pageToken === 'EOD'
                && initialStoriesLoaded)
                && (
                  <RecommendedStories
                    loadingStories={loading}
                    storiesLength={storiesArr.length}
                    oldStories={storiesArr}
                    premiumPage
                    isAdvancedView={isAdvancedView}
                    isMajorOnly={isMajorOnly}
                    whiteListId={whiteListId}
                    classname={classname}
                  />
                )}

              {storiesArr.length >= 30 && pageToken === 'EOD' && (
                <StoryCaughtUp hideButton />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  storyFilters, stories, locationsSentiment, subscriptions,
  common, watchlistReducer,
}) => {
  const { permissions } = subscriptions;
  const isGold = permissions.access_levels.includes(GOLD);
  return {
    storyFilters,
    stories: stories.cards,
    loading: stories.loading,
    activatePreloader: stories.activatePreloader,
    freezeStories: stories.freeze_stories,
    selectedMainTimePeriod: locationsSentiment.selectedMainTimePeriod,
    selectedLocation: locationsSentiment.selectedLocation,
    isGold,
    windowWidth: common.width,
    earliestSearchDate: permissions.earliest_search_date,
    token: watchlistReducer.userToken,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    ...storyFiltersActions,
    ...storyActions,
    ...preferencesActions,
    ...locationsSentiment,
  }, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(permissionsDecorator(PremiumStories)),
);
